export const DAO_CODE = "CONTRACTS_DAO"
